module.exports = __webpack_public_path__ + "img/pic2.740a7051.png";